let recaptcha;

const getSrcUrl = function() {
  return [
    'https://www.google.com/recaptcha/api.js',
    '?hl=',
    document.documentElement.lang,
    '&onload=onRecaptchaLoad',
    '&render=explicit',
  ].join('');
};

const importRecaptcha = function() {
  return new Promise(function(resolve, reject) {
    const script = document.createElement('script');

    script.src = getSrcUrl();
    window.onRecaptchaLoad = resolve;
    script.onerror = reject;

    document.body.appendChild(script);
  });
};

const load = function() {
  if (!recaptcha.loading) {
    if (window.grecaptcha) {
      recaptcha.loading = Promise.resolve(window.grecaptcha);
    } else {
      recaptcha.loading = importRecaptcha()
        .then(() => window.grecaptcha);
    }
  }

  return recaptcha.loading;
};

recaptcha = {
  load,
  loading: null,
};

export default recaptcha;
